// extracted by mini-css-extract-plugin
export default {"teamCard":"RoutConstructor_teamCard__IVoQD","wrapper":"RoutConstructor_wrapper__6MQqt","localBtn":"RoutConstructor_localBtn__hMxZR"};